
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IWbuAccordionProps,
  IWbuAccordionMapperProps,
  IWbuAccordionControllerProps,
  IWbuAccordionStateValues,
} from '../../../components/WbuAccordion/WbuAccordion.props';

export default withCompController<
  IWbuAccordionMapperProps,
  IWbuAccordionControllerProps,
  IWbuAccordionProps,
  IWbuAccordionStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { editorType } = stateValues
  return {
    ...mapperProps,
    editorType,
    updateComponentPropsInViewer: props => {
      controllerUtils.updateProps(props);
    }
  }
});
